import { useKeycloak } from '@react-keycloak/web';
import React, {
  createContext,
  useContext,
  useState,
  useEffect,
  ReactNode,
} from 'react';

interface AuthContextType {
  auth: string[];
  setAuth: (value: string[]) => void;
}

const AuthContext = createContext<AuthContextType | undefined>(undefined);

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};

export const AuthProvider: React.FC<{ children: ReactNode }> = ({
  children,
}) => {
  const { keycloak, initialized } = useKeycloak();
  const [auth, setAuth] = useState<string[]>(['admin']);
  useEffect(() => {
    if (initialized && keycloak?.authenticated) {
      const roles = keycloak?.tokenParsed?.resource_access?.[
        'api-service-client'
      ]?.roles || ['admin'];
      setAuth(roles);
    }
  }, [initialized, keycloak]);

  return (
    <AuthContext.Provider value={{ auth, setAuth }}>
      {children}
    </AuthContext.Provider>
  );
};
